import dashboardEditor from './source/dashboard-editor.json';
import dashboardManagement from './source/dashboard-management.json';
import insightsLocale from './source/insights.json';
import whatsNew from './source/whats-new.json';
import widgetBuilder from './source/widget-builder.json';

const en = {
  ...insightsLocale,
  dashboardEditor,
  dashboardManagement,
  whatsNew,
  widgetBuilder,
};

export default en;
